
export default function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center pt-20 overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img 
          src="https://public.readdy.ai/ai/img_res/bd545f767cf957d84ae9229f78df9b7d.jpg" 
          alt="Business Consulting" 
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/40"></div>
      </div>
      
      <div className="relative z-10 max-w-[1400px] mx-auto px-6 py-20 w-full">
        <div className="max-w-[700px]">
          <div className="inline-flex items-center gap-2 bg-[#D4AF37]/20 backdrop-blur-sm border border-[#D4AF37]/30 px-4 py-2 rounded-full mb-6">
            <div className="w-2 h-2 bg-[#D4AF37] rounded-full"></div>
            <span className="text-[13px] font-medium text-white">Trusted by 500+ Businesses</span>
          </div>
          
          <h1 className="font-['Playfair_Display',serif] text-[64px] leading-[1.1] font-bold text-white mb-6">
            Navigate Government Contracting with Confidence
          </h1>
          
          <p className="text-[18px] text-gray-200 leading-relaxed mb-10 font-light">
            Expert LLC formation, tax services, and compliance solutions for ambitious entrepreneurs in the US and UK
          </p>
          
          <div className="flex items-center gap-4 mb-12">
            <button onClick={() => scrollToSection('contact')} className="bg-[#1A2B3C] text-white px-8 py-4 rounded-lg text-[15px] font-semibold hover:bg-[#D4AF37] transition-all duration-300 whitespace-nowrap cursor-pointer">
              Schedule Consultation →
            </button>
            <button onClick={() => scrollToSection('services')} className="bg-transparent border-2 border-white text-white px-8 py-4 rounded-lg text-[15px] font-semibold hover:bg-white hover:text-[#1A2B3C] transition-all duration-300 whitespace-nowrap cursor-pointer">
              View Services
            </button>
          </div>
          
          <div className="flex items-center gap-8 opacity-80">
            <div className="flex items-center gap-2">
              <i className="ri-shield-check-line text-[#D4AF37] text-xl"></i>
              <span className="text-[13px] text-white">SAM.gov Certified</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-government-line text-[#D4AF37] text-xl"></i>
              <span className="text-[13px] text-white">Government Approved</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-award-line text-[#D4AF37] text-xl"></i>
              <span className="text-[13px] text-white">US & UK Licensed</span>
            </div>
          </div>
        </div>
        
        <div className="absolute bottom-12 right-12 bg-white/95 backdrop-blur-sm p-6 rounded-2xl shadow-2xl max-w-[240px]">
          <div className="text-[48px] font-bold text-[#1A2B3C] leading-none mb-1">98%</div>
          <div className="text-[14px] text-gray-600 mb-3">Client Satisfaction</div>
          <div className="flex gap-1">
            <i className="ri-star-fill text-[#D4AF37] text-lg"></i>
            <i className="ri-star-fill text-[#D4AF37] text-lg"></i>
            <i className="ri-star-fill text-[#D4AF37] text-lg"></i>
            <i className="ri-star-fill text-[#D4AF37] text-lg"></i>
            <i className="ri-star-fill text-[#D4AF37] text-lg"></i>
          </div>
        </div>
      </div>
    </section>
  );
}
